
import React from 'react';
import { Progress } from '@/components/ui/progress';
import { cn } from '@/lib/utils';

const BillAuditingPanel = () => {
  // Sample data - would come from API in real app
  const auditStats = [
    {
      label: 'Savings Identified',
      value: '$24,520',
      change: '+12%',
      changeType: 'positive',
    },
    {
      label: 'Bills Audited',
      value: '124',
      change: '+8%',
      changeType: 'positive',
    },
    {
      label: 'Issues Found',
      value: '38',
      change: '-5%',
      changeType: 'negative',
    },
  ];

  const auditProgress = [
    {
      label: 'Electric',
      percentage: 92,
      color: 'bg-blue-500',
    },
    {
      label: 'Natural Gas',
      percentage: 78,
      color: 'bg-yellow-500',
    },
    {
      label: 'Water',
      percentage: 65,
      color: 'bg-green-500',
    },
  ];

  return (
    <div className="p-6 text-gray-800 dark:text-white h-full flex flex-col">
      <h2 className="text-2xl font-bold text-center mb-6">Bill Auditing</h2>
      
      <div className="grid grid-cols-3 gap-6 mb-8">
        {auditStats.map((stat, index) => (
          <div key={index} className="flex flex-col items-center">
            <p className="text-sm text-gray-500 dark:text-gray-400">{stat.label}</p>
            <p className="text-3xl font-bold mt-1">{stat.value}</p>
            <p
              className={cn(
                'text-sm font-medium mt-1',
                stat.changeType === 'positive' ? 'text-green-500' : 'text-red-500'
              )}
            >
              {stat.change}
            </p>
          </div>
        ))}
      </div>

      <h3 className="text-lg font-medium text-center mb-6">Audit Progress</h3>
      <div className="space-y-6">
        {auditProgress.map((item, index) => (
          <div key={index} className="space-y-2">
            <div className="flex justify-between text-sm">
              <span>{item.label}</span>
              <span>{item.percentage}%</span>
            </div>
            <Progress 
              value={item.percentage} 
              className="h-2 bg-gray-200 dark:bg-gray-700" 
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default BillAuditingPanel;
